<template>

    <div class="excavate-association">
        <div class="excavate-tip"><span></span> 颜色相同的标记为同一类，对应的是表格中显示clusterId 相同的表示同一类。</div>
        <analysisOption @option_click='option_click'> </analysisOption>
        <div class="flex-end">
            <el-button  type="primary" size="small" @click='association_click'>社团分析</el-button>
        </div>
    </div>
</template>

<script>
import analysisOption from "./comps/analysis_option.vue"
import excavateData from "./comps/excavateData.js"
export default {
    components: {
        analysisOption,
    },
    data () {
        return {
            // 和组件内部的值保持统一
            beforeRadio:'clinicalFeature',
            beforeValue:'临床表现',
            afterRadio:'clinicalFeature',
            afterValue:'临床表现',

            radioOption:excavateData.radioOption
        }
    },
    methods: {
        // 获取选择后的值
        option_click(params){
            if(params.type=='before'){
                this.beforeRadio = params.val;
                this.beforeValue=params.valName
            }else if(params.type=='after'){
                this.afterRadio = params.val;
                this.afterValue=params.valName
            }
        },
        // 社团分析
        association_click(){ 
            let optionLable ='';
            if(this.beforeRadio==this.afterRadio){
                optionLable=this.beforeRadio
            }else{
                optionLable=`${this.beforeRadio},${this.afterRadio}`
            }
            this.$router.push({
                path:'detailsAssociation',
                query:{
                    optionLable,
                    beforeValue:this.beforeValue,
                    afterValue:this.afterValue,
                }
            }) 
        },
    }
}
</script>

<style>

</style>